import { FC } from "react";

import { MenuItem } from "services/app/types";

import SiteMapColumnItem from "./SiteMapColumnsItem";

interface FooterColumnProps {
  menuItems: MenuItem[];
}

const FooterColumn: FC<FooterColumnProps> = ({ menuItems }) => (
  <div className="-col">
    {menuItems.map((menuItem: MenuItem, index: number) => (
      <SiteMapColumnItem
        menuItem={menuItem}
        key={`${index}-${menuItem.name}`}
      />
    ))}
  </div>
);

export default FooterColumn;
